export default __webpack_public_path__ + "img/app-page/androidBack.7f9f9a900d7e063c249faaa588edeb2e.png";